import RoleButton from 'components/RoleButton';
import React from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { selectSelectedTableCellRows } from 'services/selectedTableCells/selectors';
import { ADMIN } from 'components/RoleGate/constants';

export default function ExportPeopleButton(): React.ReactElement | null {
    const ids: number[] = useSelector(selectSelectedTableCellRows);

    if (!ids.length) {
        return null;
    }

    return (
        <RoleButton
            requiredRoles={[ADMIN]}
            params={{ EXPORT_PEOPLE_MODAL: true }}
        >
            Export People
        </RoleButton>
    );
}
